const questionGradedStatusTemplate = ({correctTextString, incorrectTextString}) => `<div class="question-grade-status-text question-correct-text hide-element">${correctTextString}</div>
<div class="question-grade-status-text question-incorrect-text hide-element">${incorrectTextString}</div>
`;

export default questionGradedStatusTemplate;
